import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class StepsDataService {
	currentStepIndex = 0;
	currentStepID: string;
	steps = [];

	constructor() { }
}
